module.exports = __webpack_public_path__ + "img/full_bg.f9f202af.png";